import { createSlice, createSelector } from '@reduxjs/toolkit';
import {
  fetchPcaModel,
  fetchCopulaModel,
  fetchPortfolioSimulations,
  generateModelKey
} from "../../api/analyticsApi";

const initialState = {
  models: {},
    portfolioSimulations: {},

  latestModel: null,
  status: 'idle',
  error: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Helper to handle each thunk's pending/fulfilled/rejected
    const addModelCases = (thunk) => {
      builder
        .addCase(thunk.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(thunk.fulfilled, (state, action) => {
          state.status = 'succeeded';

          // Build the same key used in condition:
          const key = generateModelKey(action.payload.modelName, action.meta.arg);
          console.log('Fulfilled key ->', key);


          state.models[key] = action.payload;
          state.latestModel = key;
        })
        .addCase(thunk.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.payload;
        });
    };

    // Attach the handlers for each thunk
    addModelCases(fetchPcaModel);
    addModelCases(fetchCopulaModel);
    builder
      .addCase(fetchPortfolioSimulations.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPortfolioSimulations.fulfilled, (state, action) => {
        state.status = 'succeeded';

        // If we included symbols/nPaths/freq/etc. in the payload, we can do:
        const {
          modelName,
          symbols,
          nPaths,
          freq,
          initialCapital,
          nYears
        } = action.payload;

        // Rebuild the key from the payload
        const key = generateModelKey(modelName, {
          symbols,
          nPaths,
          freq,
          initialCapital,
          nYears
        });

        // Save to portfolioSimulations
        state.portfolioSimulations[key] = action.payload;
        state.latestModel = key;
      })
      .addCase(fetchPortfolioSimulations.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    },
});

export const selectModels = (state) => state.analytics.models;
export const selectLatestModel = (state) => state.analytics.latestModel;
export const selectStatus = (state) => state.analytics.status;
export const selectError = (state) => state.analytics.error;

export const selectPortfolioSimulationsState = (state) => state.analytics.portfolioSimulations;

// This is a utility to get a specific simulation by arguments
export const selectPortfolioSimulations = createSelector(
  [selectPortfolioSimulationsState, (_, args) => args],
  (portfolioSimulations, args) => {
    if (!args) return null;
    const key = generateModelKey('portfolioSimulation', args);
    return portfolioSimulations[key];
  }
);

// If you need to check the latest data in general

// Or if you want to see if the latest model is a portfolio sim
export const selectLatestPortfolioSimulation = createSelector(
  [selectPortfolioSimulationsState, selectLatestModel],
  (portfolioSimulations, latestKey) => {
    if (!latestKey || !portfolioSimulations[latestKey]) return null;
    const model = portfolioSimulations[latestKey];
    return model.modelName === 'portfolioSimulation' ? model : null;
  }
);

/** Get whichever was the most recently set model in general */
export const selectLatestModelData = createSelector(
  [selectModels, selectLatestModel],
  (models, latestKey) => (latestKey ? models[latestKey] : null)
);

export default analyticsSlice.reducer;
